import {User as UserTypes} from './types'
import {combineReducers} from 'redux'

function users(state = [], action) {
  return state
}

function addresses(state = [], action) {
  return state
}

function objects(state = [], action) {
  return state
}

function categories(state = [], action) {
  return state
}

function timeSlots(state = [], action) {
  return state
}

const initialUser = {
  id: 0,
  email: '',
  name: '',
  lastName: '',
  permissions: [],
  token: '',
  profilePicture: '',
  items: 0,
  phone: '',
  fbUser: false,
}

function user(state = initialUser, action) {
  switch (action.type) {
    case UserTypes.SET_FIRST_TIME:
      return Object.assign({}, state, {
        id: action.user.id,
        email: action.user.email,
        name: action.user.name,
        lastName: action.user.lastName,
        permissions: action.user.permissions,
        token: action.user.token,
        profilePicture: action.user.profilePicture,
        missingProfileInformation: action.user.missingProfileInformation || [],
        items: 0,
        phone: '',
        fbUser: action.user.fbUser,
      })
    case UserTypes.UPDATE_USER_INFO_SUCCESS:
      const data = action.payload.user
      return Object.assign({}, state, {
        id: data.id,
        email: data.email,
        name: data.name,
        lastName: data.lastName,
        permissions: data.permissions,
        token: data.token,
        profilePicture: data.profilePicture,
        missingProfileInformation: data.missingProfileInformation,
        items: data.items,
        phone: data.phone,
      })
    case UserTypes.LOG_OUT:
      return Object.assign({}, state, initialUser)
    default:
      return state
  }
}

export default combineReducers({user, users, addresses, objects, categories, timeSlots})



// WEBPACK FOOTER //
// ./src/state/reducers.js